import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  question: '¿Es un solo pago?',
  answer: 'Sí, pago único. Nada de suscripciones mensuales.'
}, {
  question: '¿Funciona en piel madura?',
  answer: 'Es donde mejor funciona. El ciclo de 4 noches acelera la renovación celular que se ralentiza con la edad.'
}, {
  question: '¿Y si ya tengo productos?',
  answer: 'La guía te enseña a organizarlos. Si te falta algo, te doy la opción más económica y potente.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-20 px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-primary mb-12 font-serif" data-id="element-3">
          FAQ Rápida
        </h2>

        <div className="space-y-4" data-id="element-4">
          {faqs.map((faq, index) => <div key={index} className="border border-brown-secondary/20 rounded-lg bg-white overflow-hidden" data-id="element-5">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-6">
                <span className="text-lg font-bold text-brown-primary" data-id="element-7">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-rose-gold shrink-0 ml-4" data-id="element-8" /> : <ChevronDownIcon className="w-5 h-5 text-brown-secondary shrink-0 ml-4" data-id="element-9" />}
              </button>

              {openIndex === index && <div className="px-6 pb-6 text-brown-secondary leading-relaxed animate-in slide-in-from-top-2 duration-200" data-id="element-10">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}